import { toast, type ExternalToast } from "sonner";
import CustomToast from "./CustomToast";
import type { ToastType } from "./CustomToast.types";

export const displayMessage = (
  message: string,
  type: ToastType,
  data?: ExternalToast,
) => {
  toast.custom(() => <CustomToast message={message} type={type} />, data);
};
